import { render } from "./About.vue?vue&type=template&id=31b65c36"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aacassandra/Documents/vue3/aacassandra-github/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__